import img1 from '../../../../assets/images/news1.jpg';
import img2 from '../../../../assets/images/news2.jpg';
import img3 from '../../../../assets/images/news3.jpg';
import img4 from '../../../../assets/images/news4.jpg';

export const newsList = [
	{
		img: img1,
		link: 'https://www.infranews.ru/logistika/67956-pravitelstvo-podmoskovya-reshilo-otregulirovat-kontejnernye-ploshhadki/',
		title: 'Правительство Подмосковья решило отрегулировать контейнерные площадки',
		text: 'Власти Московской области намерены ввести новые специальные требования для транспортно-логистических центров на территории региона, в первую очередь, для контейнерных терминалов и складов. Часть контейнерных операторов поддержала инициативу, но большинство опрошенных InfraNews отнеслись к ней с тревогой, называя новые требования незаконными, невыполнимыми для большинства игроков рынка и крайне вредными для логистики московской агломерации.',
		date: 'Июнь 17, 2025, 19:39',
	},

	{
		img: img2,
		link: 'https://www.infranews.ru/logistika/68092-gubernator-moskovskoj-oblasti-utverdil-novye-pravila-dlya-kontejnernyh-ploshhadok/',
		title: 'Губернатор Московской области утвердил новые правила для контейнерных площадок',
		text: 'С 7 июля 2025 года в Московской области начнут действовать новые правила для размещения грузовых контейнеров. Соответствующее постановление за подписью губернатора региона Андрея Воробьева опубликовано на портале правительства Московской области 2 июля.',
		date: 'Июль 03, 2025, 11:58',
	},

	{
		img: img3,
		link: 'https://www.infranews.ru/logistika/sujeti/68513-mintrans-rossii-raskritikoval-novye-pravila-razmeshheniya-kontejnerov-v-podmoskove/',
		title: 'Минтранс России раскритиковал новые правила размещения контейнеров в Подмосковье',
		text: 'Новые требования властей Московской области к контейнерным площадкам невыполнимы в указанные сроки и вызывают вопросы в целесообразности, сообщил Минтранс России в ответ на запрос группы депутатов Госдумы. Уже сейчас контролирующие органы Подмосковья требуют от операторов наличия дорогостоящего оборудования, поставка и сертификация которого занимает не менее полугода, а юридическая небрежность, с которой составлен нормативный акт, скорее всего, натолкнется на противоречия с федеральным законодательством, считают в министерстве.',
		date: 'Август 27, 2025, 13:13',
	},

	{
		img: img4,
		link: 'https://www.infranews.ru/logistika/68625-dmitrij-anisimov-ya-ne-hochu-i-ne-budu-sdavatsya/',
		title: 'Дмитрий Анисимов: "Я не хочу и не буду сдаваться"',
		text: 'Владелец сети терминалов «Тетрис» Дмитрий Анисимов рассказал InfraNews, как подмосковные власти закрывают его площадки, чем это обернется для логистики Московской агломерации и инвестиционной привлекательности региона, а также о том, почему он решил бороться за свой бизнес до конца.',
		date: 'Сентябрь 11, 2025, 17:59',
	},
];
